// extracted by mini-css-extract-plugin
module.exports = {"theme":"#023F98"};